export default function Header() {
  return (
    <header className="flex flex-col justify-center items-center">
      <h1 className="text-2xl font-bold">nTask</h1>
      <h3 className="text-lg capitalize font-medium">
        list your task to become productive
      </h3>
    </header>
  );
}
